import { useEffect, useRef } from "react";

import Box from "@mui/material/Box";
import ClickAwayListener from "@mui/material/ClickAwayListener";

import { CustomFilterOption } from "./custom-filters-list.component";
import FilterChip from "./filter-chip.component";

type FilterProps = {
  metadata: any;
  option: CustomFilterOption;
  handleSetFilterData: (value: string, data: any) => void;
  handleClearMetadata: (value: string) => void;
  onStartEdit: (value: string) => void;
  onFinishEdit: (value: string) => void;
  isEdit: boolean;
  isLocked?: boolean;
  isPinned?: boolean;
};

const editContainerSx = {
  p: 1,
  border: "solid 1px #e3ccf5",
  borderRadius: "16px"
};

export default function Filter({
  metadata,
  option,
  handleSetFilterData,
  handleClearMetadata,
  onStartEdit,
  onFinishEdit,
  isEdit,
  isLocked = false,
  isPinned = false
}: FilterProps) {
  const containerRef = useRef<any>();

  const {
    filterKey,
    label,
    editComponent,
    onDelete,
    renderViewMode,
    onEditTriggered
  } = option;

  useEffect(() => {
    if (isEdit && containerRef.current && onEditTriggered) {
      onEditTriggered(filterKey);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isEdit, containerRef]);

  const handleDelete = () => {
    handleClearMetadata(filterKey);
    if (onDelete) {
      onDelete(filterKey);
    }
  };

  const handleClick = () => {
    if (editComponent) {
      onStartEdit(filterKey);
    }
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter" || event.key === "Escape") {
      onFinishEdit(filterKey);
    }
  };

  if (isEdit && editComponent) {
    return (
      <ClickAwayListener
        onClickAway={() => {
          handleSetFilterData(filterKey, metadata);
          onFinishEdit(filterKey);
        }}
      >
        <Box sx={editContainerSx} onKeyDown={handleKeyDown}>
          {editComponent(filterKey, (data) => {
            handleSetFilterData(filterKey, data);
            if (!Array.isArray(data)) {
              onFinishEdit(filterKey);
            }
          })}
        </Box>
      </ClickAwayListener>
    );
  }
  return (
    <Box ref={containerRef} sx={{ mb: 1, mr: 1 }}>
      <FilterChip
        label={renderViewMode ? renderViewMode(filterKey, metadata) : label}
        onDelete={handleDelete}
        onClick={handleClick}
        isLocked={isLocked}
        isPinned={isPinned}
      />
    </Box>
  );
}
